var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"chat-container ma-auto",style:({ fontFamily: _vm.theme.getFont })},[_c('EcsCustomerChatHeader'),_c('EcsCustomerChatBody'),_c('EcsCustomerChatFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }